import { render, staticRenderFns } from "./CostSummaryDialog.vue?vue&type=template&id=90450058&scoped=true"
import script from "./CostSummaryDialog.vue?vue&type=script&lang=ts"
export * from "./CostSummaryDialog.vue?vue&type=script&lang=ts"
import style0 from "./CostSummaryDialog.vue?vue&type=style&index=0&id=90450058&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90450058",
  null
  
)

export default component.exports